var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "confirm-form" }, [
    _c("section", { staticClass: "confirm-section" }, [
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_setup.t("contestEntryForm.step3.applicantSection"))),
      ]),
      _c(
        "dl",
        { staticClass: "confirm-fields" },
        _vm._l(_setup.applicantFields, function (field) {
          return _c("div", { key: field.key, staticClass: "confirm-field" }, [
            _c("dt", { staticClass: "confirm-label" }, [
              _vm._v(_vm._s(field.label)),
            ]),
            _c(
              "dd",
              {
                staticClass: "confirm-value",
                class: { "confirm-value-multiline": field.multiline },
              },
              [_vm._v(_vm._s(field.value))]
            ),
          ])
        }),
        0
      ),
    ]),
    _c("section", { staticClass: "confirm-section" }, [
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_setup.t("contestEntryForm.step3.workSection"))),
      ]),
      _c(
        "dl",
        { staticClass: "confirm-fields" },
        [
          _vm.categoryLabel
            ? _c("div", { staticClass: "confirm-field" }, [
                _c("dt", { staticClass: "confirm-label" }, [
                  _vm._v(_vm._s(_setup.t("contestEntryDataForm.category"))),
                ]),
                _c("dd", { staticClass: "confirm-value" }, [
                  _vm._v(_vm._s(_vm.categoryLabel)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "confirm-field" }, [
            _c("dt", { staticClass: "confirm-label" }, [
              _vm._v(_vm._s(_setup.t("contestEntryForm.step3.selectedWork"))),
            ]),
            _c("dd", { staticClass: "confirm-value" }, [
              _c(
                "div",
                { staticClass: "selected-work-card" },
                [
                  _c(_setup.ImageView, {
                    staticClass: "selected-work-cover",
                    attrs: { src: _vm.workForm.novelImage },
                  }),
                  _c("p", { staticClass: "selected-work-title" }, [
                    _vm._v(_vm._s(_vm.workForm.workTitle)),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "confirm-field" }, [
            _c("dt", { staticClass: "confirm-label" }, [
              _vm._v(_vm._s(_setup.t("contestEntryForm.step2.synopsis.label"))),
            ]),
            _c("dd", { staticClass: "confirm-value confirm-value-multiline" }, [
              _vm._v(_vm._s(_vm.workForm.synopsis)),
            ]),
          ]),
          _vm._l(_vm.extraFieldItems, function (field) {
            return _c("div", { key: field.key, staticClass: "confirm-field" }, [
              _c("dt", { staticClass: "confirm-label" }, [
                _vm._v(_vm._s(field.title)),
              ]),
              _c(
                "dd",
                { staticClass: "confirm-value confirm-value-multiline" },
                [_vm._v(_vm._s(_vm.workForm.extraAnswers?.[field.key] ?? ""))]
              ),
            ])
          }),
        ],
        2
      ),
    ]),
    _vm.submitError
      ? _c("p", { staticClass: "submit-error", attrs: { role: "alert" } }, [
          _vm._v(_vm._s(_vm.submitError)),
        ])
      : _vm._e(),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "button",
        {
          staticClass: "back-button",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _setup.emit("back")
            },
          },
        },
        [_vm._v(" " + _vm._s(_setup.t("contestEntryForm.step3.back")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "submit-button",
          attrs: { type: "button", disabled: _vm.submitting },
          on: {
            click: function ($event) {
              return _setup.emit("submit")
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.submitting
                  ? _setup.t("contestEntryForm.step3.submitting")
                  : _setup.t("contestEntryForm.step3.submit")
              ) +
              " "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }